import IHelp from '@/interfaces/help';
import { API_BASE_URL } from '@/settings';

import { get, post } from './api';

export interface IHelpData {
  name: string;
  email: string;
  cou_hash: string;
  message: string;
  title: string;
}

class HelpService {
  public async getQuestions(): Promise<{ data: IHelp }> {
    const response = await get({
      url: '/user/help',
      baseURL: API_BASE_URL
    });

    return response?.data;
  }

  public async getCourses(): Promise<{ data: IHelp }> {
    const response = await get({
      url: '/learner/course/search?size=999'
    });

    return response?.data;
  }
  public saveMessage = (data: IHelpData) => {
    return post({ url: '/user/help', baseURL: API_BASE_URL, data }).then(response => {
      return response;
    });
    // .catch(() => toastError('Não foi possível enviar a solicitação no momento'));
  };
}

const helpService = new HelpService();
export default helpService;
